import { keyBy } from '../../../../helpers/common'
import { register } from '../../../../helpers/reducerRegistry'
import { valByKeyWithDot } from '../../../../helpers/value'
import { ALL_STATUS } from '../constants'
import {
  getListOrdersThunk,
  getTransactionStatusAndOrderStatusThunk,
} from './thunk'
const { createSlice } = require('@reduxjs/toolkit')

const slice = createSlice({
  name: 'userManagement/subscriptionPayment/orderManagement',
  initialState: {
    isLoadingTransactionAndOrderStatus: true,
    transactionStatus: [],
    orderStatus: [],
    isLoadingListOrders: true,
    orders: {
      ids: [],
      dataById: {},
      origData: [],
    },
    filterOptions: {
      orderStatusActive: ALL_STATUS,
      transactionStatusActive: ALL_STATUS,
      page: 1,
      pageSize: 10,
      from: undefined,
      to: undefined,
      totalRecords: 0,
    },
  },
  reducers: {
    changeFilter: (state, { payload = {} }) => {
      state.filterOptions = {
        ...state.filterOptions,
        ...payload,
      }
      if (!Object.keys(payload)?.includes('page')) {
        state.filterOptions.page = 1
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTransactionStatusAndOrderStatusThunk.pending, (state) => {
        state.isLoadingTransactionAndOrderStatus = true
        state.transactionStatus = []
        state.orderStatus = []
      })
      .addCase(
        getTransactionStatusAndOrderStatusThunk.fulfilled,
        (state, { payload = {} }) => {
          state.isLoadingTransactionAndOrderStatus = false
          state.transactionStatus = payload.transactionStatus
          state.orderStatus = payload.orderStatus
        },
      )
      .addCase(
        getTransactionStatusAndOrderStatusThunk.rejected,
        (state, { payload = {} }) => {
          state.isLoadingTransactionAndOrderStatus = payload.isLoading
        },
      )

    builder
      .addCase(getListOrdersThunk.pending, (state) => {
        state.isLoadingListOrders = true
      })
      .addCase(getListOrdersThunk.fulfilled, (state, action) => {
        state.isLoadingListOrders = false

        const payloadData = action.payload
          ? action.payload.data.map((item, index) => ({
              ...item,
              order: index + 1,
            }))
          : []

        state.orders.ids = payloadData.map((item) => item.id)
        state.orders.origData = action.payload.data
        state.orders.dataById = keyBy(payloadData, 'id')
        state.filterOptions.totalRecords = action.payload.totalRecords
      })
      .addCase(getListOrdersThunk.rejected, (state, { payload = {} }) => {
        state.isLoadingListOrders = payload.isLoading
      })
  },
})

register(slice.name, slice.reducer)

export const selectIsLoadingTransactionAndOrderStatus = (state) =>
  state[slice.name].isLoadingTransactionAndOrderStatus
export const selectTransactionStatus = (state) =>
  state[slice.name].transactionStatus
export const selectOrderStatus = (state) => state[slice.name].orderStatus
export const selectIds = (state) => state[slice.name].orders.ids
export const selectOrdersDataById = (id, attr) => (state) =>
  valByKeyWithDot(state[slice.name].orders.dataById[id], attr)
export const selectFilterByKey = (key) => (state) =>
  state[slice.name].filterOptions[key]
export const selectIsLoadingListOrders = (state) =>
  state[slice.name].isLoadingListOrders
export const selectOrdersData = (state) => state[slice.name].orders.origData
export const selectDataByIdOrder = (state) => state[slice.name].orders.dataById

export const { changeFilter } = slice.actions
